// extracted by mini-css-extract-plugin
module.exports = {"modal":"SimpleModal_modal__11efd"};